module.exports = __webpack_public_path__ + "assets/5d29ac4b36af41453f70aa5410031cb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/cz/2.png
// module id = 367
// module chunks = 1